import React from 'react';
import { Controller, useForm } from 'react-hook-form';

function Search({ onSearch, label }) {
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: { search: '' },
    mode: 'onChange'
  });

  const onSubmit = (val) => {
    onSearch(val.search);
  };

  const onClear = () => {
    setValue('search', '');
    onSearch('');
  };

  return (
    <form className="search" onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="search"
        render={({ field: { onChange, onBlur, value } }) => (
          <div>
            <label className="search__label">{label}</label>

            <input
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="text"
              placeholder="Pencarian..."
              className="form-control search__input"
            />

            {value && (
              <button type="button" onClick={onClear} className="search__clear">
                <i className="fa fa-close text-24 text-danger"></i>
              </button>
            )}

            <button type="submit" className="search__submit">
              <i className="fa fa-search text-20 text-blue-1"></i>
            </button>
          </div>
        )}
      />
    </form>
  );
}

export default Search;
